import { render } from "./SiteFooter.vue?vue&type=template&id=28a1fe4b&scoped=true"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=28a1fe4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_0b0c69fa16feb22e92fe2dae88baf76f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a1fe4b"]])

export default __exports__